import { Link } from "react-router-dom";

import { capabilities, navLinks, site } from "../lib/site";
import { LogoMark, Wordmark } from "./Logo";

export const SiteFooter = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <div className="site-footer__grid">
        <div>
          <Link to="/" className="logo" aria-label="CatalyxLabs — home">
            <LogoMark size={30} />
            <Wordmark />
          </Link>
          <p className="site-footer__blurb">{site.tagline}</p>
        </div>

        <div>
          <h2 className="site-footer__heading">Explore</h2>
          <ul className="site-footer__list">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link className="site-footer__link" to={link.to}>
                  {link.label}
                </Link>
              </li>
            ))}
            {site.social.map((item) => (
              <li key={item.label}>
                <a
                  className="site-footer__link"
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="site-footer__heading">Get in touch</h2>
          <ul className="site-footer__list">
            <li>
              <a className="site-footer__link" href={`mailto:${site.email}`}>
                {site.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>
          © {new Date().getFullYear()} {site.name}. All rights reserved.
        </p>
        <p>{capabilities.length} disciplines, one team.</p>
      </div>
    </div>
  </footer>
);
